import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../libs/bulma.min.css';
import './TrunksView.css';
import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportSelectTrunkById, exportDeleteTrunks, changeViewForms, sendRegisterTrunkSystem, sendReloadAsteriskSystem } from '../../../services';
import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faStop, faPlay, faEdit, faExchangeAlt, faArrowsAltH, faArrowRight, faPhoneSquareAlt } from '@fortawesome/free-solid-svg-icons';

function EndpointsListById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState([]);
  const [trunksSelected, setTrunksSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [typeRegistry, setTypeRegistry] = useState('unregister');
  const [message, setMessage] = useState('');
  const [cliTrunk, setCliTrunk] = useState([]);
  const [filterText, setFilterText] = useState('');

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchTrunks = async () => {
    
    const trunkReceived = await exportSelectTrunkById({ elements: itemsSelectedToEdit.toString() });

    if(trunkReceived <= 0) return history.push('/config/tronco/lista');
    if(trunkReceived === undefined) return setLoading(true);

    const elements = trunkReceived.map((element) => {
      const result = {
        serverIP: element.serverIP.includes('@') ? element.serverIP.split(':')[1].split('@')[1] : element.serverIP.split(':')[1],
        localIP:  element.localIP.includes('@') ? element.localIP.split(':')[1].split('@')[1] : element.localIP.split(':')[1],
        nameuser: element.nameuser === null ? '' : element.nameuser,
        pass: element.pass === null ? '' : element.pass,
      };
      result.name = element.name;
      result.trunk = element.trunk;
      result.codec = element.codec;

      return result;
    });

    setPhones(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const elements = await fetchTrunks();
    return;
  }, []);

  const handleChangeSelectedTrunks = (element) => {
    setTrunksSelected((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true)
      return onlineState;
    });
  };
  
  const filteredPhones = phones.filter((phone) => {
    const searchText = filterText.toLowerCase();
    return (
      phone.name.toLowerCase().includes(searchText) ||
      phone.localIP.toLowerCase().includes(searchText) ||
      phone.serverIP.toLowerCase().includes(searchText) ||
      phone.trunk.toLowerCase().includes(searchText) ||
      phone.codec.toLowerCase().includes(searchText) ||
      (phone.nameuser && phone.nameuser.toLowerCase().includes(searchText)) ||
      (phone.pass && phone.pass.toLowerCase().includes(searchText))
    );
  });

  const handleSendRegisterTrunk = async () => {
    setIsPlaying(isPlaying ? false : true)
    setTypeRegistry((prevState) => {
      const type = prevState === 'unregister' ?  'register' : 'unregister'
      return type;
    });
    const result = await sendRegisterTrunkSystem({ type: typeRegistry, trunk: trunksSelected[0] });
    if (result.status !== 200) toggleIsHidden('#alert-registry-send');
  };

  const handleClickDelete = async () => {
    const sendDeleteTrunks = await exportDeleteTrunks(trunksSelected);
    if(sendDeleteTrunks.length === undefined) {
      toggleIsHidden('#alert-confirm-trunks-delete');
      return toggleIsChangeFormElements('alert-trunks-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-trunks-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div className="trunks-view-container">
      {loading ? (
        <Loading />
      ) : (
        <div className="trunks-content">
          <div className="trunks-view-header">
            <div className="trunks-view-title-wrapper">
              <svg className="trunks-view-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <div>
                <h1 className="trunks-view-title">Visualizar Tronco</h1>
                <p className="trunks-view-subtitle">Detalhes e gerenciamento de troncos</p>
              </div>
            </div>
            <div className="trunks-view-actions">
              <Link to="/config/tronco/lista" className="btn-action-view btn-back-view">
                <FontAwesomeIcon icon={faArrowsAltH} />
                Voltar à Lista
              </Link>
            </div>
          </div>
          <div className="alerts-section">
            <div id="alert-trunks-not-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-trunks-not-delete')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível deletar o(s) troncos selecionados.
              </div>
            </div>

            <div id="alert-endpoints-not-selected" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-endpoints-not-selected')}>×</button>
              </div>
              <div className="alert-body">
                Nenhum tronco selecionado!
              </div>
            </div>

            <div id="alert-create-endpoints" className="alert-message alert-warning is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Tronco(s) deletado(s) com sucesso!
              </div>
            </div>

            <div id="alert-confirm-trunks-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-confirm-trunks-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar o(s) tronco(s) selecionados?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-alert-confirm" onClick={() => handleClickDelete()}>
                  <FontAwesomeIcon icon={faTrash} />
                  Confirmar
                </button>
                <button className="btn-alert btn-alert-cancel" onClick={() => {
                  toggleIsHidden('#alert-confirm-trunks-delete');
                  toggleIsHidden('#buttons');
                }}>
                  Cancelar
                </button>
              </div>
            </div>

            <div id="alert-registry-send" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-registry-send')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível registrar/desregistrar o tronco!
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por nome, IP, tronco, codec, usuário ou senha..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredPhones.length} de {phones.length} tronco(s)
            </div>
          </div>

          <div className="trunks-table-wrapper">
            <table className="trunks-table">
              <thead className="trunks-table-header">
                <tr>
                  <th>Sel.</th>
                  <th>Nome</th>
                  <th>IP Local</th>
                  <th>IP Remoto</th>
                  <th>Tronco</th>
                  <th>Codec</th>
                  <th>Usuário</th>
                  <th>Senha</th>
                  <th className="th-actions">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredPhones.map((phone) => {
                  const { name, localIP, serverIP, trunk, codec, nameuser, pass } = phone;
                  return (
                    <tr key={name}>
                      <td>
                        <input 
                          name="selectTrunk" 
                          id={name} 
                          type="radio" 
                          value={name} 
                          onClick={(e) => handleChangeSelectedTrunks(e.target.value)}
                        />
                      </td>
                      <td className="td-name">{name}</td>
                      <td>{localIP}</td>
                      <td>{serverIP}</td>
                      <td>{trunk}</td>
                      <td style={{ textTransform: 'uppercase' }}>{codec}</td>
                      <td>{!nameuser ? 'N/A' : nameuser}</td>
                      <td>{!pass ? 'N/A' : pass}</td>
                      <td className="td-actions">
                        <div className="trunk-actions-cell">
                          <button
                            className="btn-trunk-action btn-unregister"
                            onClick={() => {
                              toggleIsHidden('#alert-confirm-trunks-delete');
                              toggleIsHidden('#buttons');
                            }}
                            disabled={disable}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                          <button
                            className="btn-trunk-action btn-register"
                            onClick={() => handleSendRegisterTrunk()}
                            disabled={disable}
                          >
                            {isPlaying ? (
                              <FontAwesomeIcon icon={faStop} />
                            ) : (
                              <FontAwesomeIcon icon={faPlay} />
                            )}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default EndpointsListById;
